import { ConstantRoutes } from "../../../core/constantRoutes";
import { useTranslation } from "react-i18next";
import { useNewsStore } from "../../../stores/newsStore";
import { useEffect, useState } from "react";
import NewsItem from "./newsItem";
import NewsSkeleton from "./newsSkeleton";

const News: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLanguageCode = i18n.language;
  const { news, fetchNews } = useNewsStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchNews();
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, []);

  const newsForCurrentLanguage = news.find((f) => f.lang === currentLanguageCode);

  return (
    <>
      <div className="flex flex-col z-10" id={ConstantRoutes.news}>
        <div className="max-w-screen-2xl w-full place-self-center text-center pb-10 md:pt-40 max-md:pt-10">
          <h1 className="text-4xl font-bold">{t('News')}</h1>
        </div>

        <div className="max-w-screen-2xl w-full place-self-center max-md:p-4">
          {isLoading ? (
            <NewsSkeleton />
          ) : newsForCurrentLanguage ? (
            <div className="rounded-xl h-1/2 bg-content3 flex flex-col overflow-y-auto shadow-inner">
              {newsForCurrentLanguage.records.map((record, index) => (
                <NewsItem 
                  key={index}
                  title={record.header}
                  text={record.description} 
                  date={new Date(record.published)} 
                />
              ))}
            </div>
          ) : (
            <p>NO NEWS</p>
          )}                 
        </div>        
      </div>
    </>
  );
};

export default News;